/**
 * Elder Emo: hover intent for the desktop header dropdowns.
 *
 * Horizon switches or closes a dropdown on `pointerenter` / `pointerleave` of
 * the top-level list items, with only a 50ms grace period. Moving diagonally
 * from "Elders" to its image tiles passes over "Kids" and "Toddlers", so the
 * menu flips or closes before the shopper reaches a link.
 *
 * While a dropdown is open, we hold those two events for GRACE ms in the
 * window's capture phase (ahead of Horizon's own document-level listeners), then replay them
 * only if the pointer is still where the event says it went. Keyboard and
 * focus handling are untouched.
 */
(() => {
  const GRACE = 300;
  const ITEM = '.header-menu .menu-list__list-item';
  const REPLAY = Symbol('ee-replay');

  let enterTimer;
  let leaveTimer;

  const isItem = (el) => el instanceof Element && el.matches(ITEM);
  const openItem = () => document.querySelector(`${ITEM}:has([aria-expanded='true'])`);

  const replay = (el, type) => {
    const event = new PointerEvent(type, { bubbles: false });
    event[REPLAY] = true;
    el.dispatchEvent(event);
  };

  window.addEventListener(
    'pointerenter',
    (event) => {
      const item = event.target;
      if (!isItem(item) || event[REPLAY]) return;

      const open = openItem();
      if (!open || open === item) return;

      // Another dropdown is open: only switch if the pointer stays here.
      event.stopImmediatePropagation();
      clearTimeout(enterTimer);
      enterTimer = setTimeout(() => {
        if (item.matches(':hover') && !open.matches(':hover')) {
          clearTimeout(leaveTimer);
          replay(item, 'pointerenter');
        }
      }, GRACE);
    },
    true
  );

  window.addEventListener(
    'pointerleave',
    (event) => {
      const item = event.target;
      if (!isItem(item) || event[REPLAY]) return;
      if (!item.querySelector("[aria-expanded='true']")) return;

      // Leaving the open dropdown: only close if the pointer doesn't come back
      // (to the item or its panel) and hasn't settled on another item.
      event.stopImmediatePropagation();
      clearTimeout(leaveTimer);
      leaveTimer = setTimeout(() => {
        if (item.matches(':hover')) return;
        const other = document.querySelector(`${ITEM}:hover`);
        if (other) {
          replay(other, 'pointerenter');
        } else {
          replay(item, 'pointerleave');
        }
      }, GRACE);
    },
    true
  );
})();
